module.exports = __webpack_public_path__ + "static/image2-e94a98758180502f8d6c4a656485952e.png";